import React, { useRef } from 'react'
import { useIntersection } from './useIntersection';

export const FadeInSection = ({ 
  left, right, top, bottom,
  rootMargin="0px 0px 0px 0px", 
  threshold=0, translate="15%",
  className="", style={}, children, 
  duration=800,
  ...rest 
}) => {
  const ref = useRef();
  const { hasEnteredView } = useIntersection({ rootMargin, threshold, ref });

  return (
    <div
      className={`
        transform transition-all ease-out
        ${ className }
      `}
      style={{
        ...style,
        opacity: hasEnteredView ? 100 : 0,
        translate: hasEnteredView ? `0 0` : right ? `${translate} 0` : (left ? `-${translate} 0` : top ? `0 -${translate}` : `0 ${translate}`) ,
        transitionDuration: `${duration}ms`,
      }}
      ref={ref}
      { ...rest }
    >
      { children }
    </div>
  )
}
